import { ActionCreator } from 'redux';
import { ToggleSnackBarPopupVisibilityAction } from './type';
import { TOGGLE_SNACKBAR_VISIBILITY } from './constants';


export const toggleSnackBarPopupVisibility: ActionCreator<ToggleSnackBarPopupVisibilityAction> = (show: boolean) => ({
    type: TOGGLE_SNACKBAR_VISIBILITY,
    payload: {
        show
    },
});


// WEBPACK FOOTER //
// ./src/store/SnackBarPopup/actions.ts